import * as React from "react";
const CorePopoverContext = React.createContext({
  excludeClickOutsideClasses: []
});
export {
  CorePopoverContext
};
//# sourceMappingURL=CorePopoverContext.js.map
